import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log the real error so it stays visible (we do NOT hide the dev overlay)
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Runtime error captured:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-md p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-red-100 text-red-600 grid place-items-center mx-auto mb-4 text-2xl font-bold">!</div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-900 mb-2">Une erreur est survenue</h1>
          <p className="text-slate-600 text-sm mb-4">
            L'application a rencontré un problème. Vos données sont en sécurité. Rechargez la page pour continuer.
          </p>
          {this.state.error?.message && (
            <pre className="text-left text-xs bg-slate-100 rounded p-3 mb-4 overflow-auto max-h-32 text-slate-600">
              {String(this.state.error.message)}
            </pre>
          )}
          <button
            data-testid="error-boundary-reload"
            onClick={this.handleReload}
            className="h-12 px-6 rounded-md font-bold bg-[#0284C7] hover:bg-[#0369A1] text-white"
          >
            Recharger l'application
          </button>
        </div>
      </div>
    );
  }
}
